<template>
    <BasePanel
        :headline="panelDetails[0]['title']"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-container fluid>
                <v-row>
                    <v-col :alvqa="alvqa + '-description'">
                        {{ $t(panelDetails[0]['description']) }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-data-table
                            :headers="digitalDistributionHeaders"
                            :items="panelDetails"
                            hide-default-footer
                            class="noMinWidth"
                            :header-props="{ sortIcon: '' }"
                        >
                            <!-- Headers -->
                            <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                                <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                            </template>

                            <!-- price header gets another text -->
                            <template v-slot:[`header.price`]="{ header }">
                                <span :alvqa="header.alvqa">
                                {{ $t('lang_ACCOUNT_MODULES_CAPTION_SPLIT') + ' %'}}
                                </span>
                            </template>

                            <!-- bookedOn header gets another text -->
                            <template v-slot:[`header.bookedOn`]="{ header }">
                                <span :alvqa="header.alvqa">
                                {{ $t('lang_ACCOUNT_MODULES_CAPTION_START_OF_CONTRACT') }}
                                </span>
                            </template>

                            <!-- Items -->
                            <template v-slot:[`item.status`]="{ item }">
                                <div :alvqa="alvqa + '-' + item.moduleName.replace(/_/g, '-') + '-panel-text-status'">
                                    <v-checkbox
                                        class="mt-0"
                                        v-model="item.status"
                                        hide-details
                                        @change="openChangeStatusDialogFunction(item)"
                                        :disabled="getDisabledStatus(item.disabled)"
                                    >
                                        <template v-slot:label>
                                            <span 
                                                style="font-size: 0.875rem !important;"
                                                class="black--text" 
                                                :alvqa="alvqa + '-text'"
                                            >
                                                {{ $t(getStatusLabel(item.status)) }}
                                            </span>
                                        </template>
                                    </v-checkbox>
                                </div>
                            </template>
                            
                            <template v-slot:[`item.price`]="{ item }">
                                <div
                                    class="text-right"
                                    :alvqa="alvqa + '-' + item.moduleName.replace(/_/g, '-') + '-panel-text-price'"
                                >
                                    {{ $alvPlugin.getNumberLocalization(item.price, 'number') }}
                                </div>
                            </template>
                            <template v-slot:[`item.emptySlot`]="{ item }">
                                <div :alvqa="alvqa + '-' + item.moduleName.replace(/_/g, '-') + '-panel-text-payment-cycle'">

                                </div>
                            </template>                
                            <template v-slot:[`item.paymentCycle`]="{ item }">
                                <div :alvqa="alvqa + '-' + item.moduleName.replace(/_/g, '-') + '-panel-text-payment-cycle'">
                                    {{ $t(item.paymentCycle) }}
                                </div>
                            </template>
                            <template v-slot:[`item.bookedOn`]="{ item }">
                                <div :alvqa="alvqa + '-' + item.moduleName.replace(/_/g, '-') + '-panel-text-payment-booked-on'">
                                    {{ item.bookedOn === null ? item.bookedOn : $d(new Date(item.bookedOn), 'alvDateFormat') }} 
                                </div>
                            </template>
                            <template v-slot:[`item.minimumPeriod`]="{ item }">
                                <div :alvqa="alvqa + '-' + item.moduleName.replace(/_/g, '-') + '-panel-text-minimum-period'">
                                    {{ getMinimumPeriod(item.minimumPeriod) }}
                                    {{ item.expiresOn === null ? '' : '(' + $d(new Date(item.expiresOn), 'alvDateFormat') + ')' }}
                                </div>
                            </template>
                            <template v-slot:[`item.link`]="{ item }">
                                <div :alvqa="alvqa + '-' + item.moduleName.replace(/_/g, '-') + '-panel-text-information'">
                                    <a :href="item.link" target="_blank">{{ $t('lang_ACCOUNT_MODULES_CAPTION_CLICK_HERE') }}</a>
                                </div>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'

export default {
    name: "DigitalDistributionModulePanel",
    components: {
        BasePanel
    },
    props: {
        headers: Array,
        openChangeStatusDialogFunction: {
            type: Function,
            default: () => {},
        }
    },
    data() {
        return {
            alvqa: "account-modules-digital-distribution-panel"
        }
    },
    computed: {
        panelDetails() { return [this.$store.getters.getDigitalDistributionModulePanelDetails] },
        digitalDistributionHeaders() {
            let emptySlot = {
                    text: '',
                    value: "emptySlot", 
                    align: "left", 
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + "-header-empty-slot",
                }

            // make a deep copy of the headers from modules.vue
            let newHeaders = JSON.parse(JSON.stringify(this.headers))
            
            // change alv-qa of the col "price" because in the DD panel price is names split!
            newHeaders[1]['alvqa'] = "account-modules-header-split"

            // remove the patronage column/headers
            newHeaders.splice(newHeaders.findIndex(header => header.value === "patronage"), 1)
            //Filling up the empty space with emptySlot in order to align columns with panels above
            newHeaders.splice(newHeaders.findIndex(header => header.value === "paymentCycle"),0,emptySlot)

            return newHeaders
        }
    },
    methods: {
        getDisabledStatus(disabled) {
            return disabled === null ? false : true
        },
        getMinimumPeriod(minimumPeriod) {
            let splitArr = minimumPeriod.split(' ')
            let str = splitArr[0] + ' ' + this.$t(splitArr[1])
            return str
        },
        getStorageOptions(storageOptionDb) {
            let items = []

            for(let [key, element] of Object.entries(storageOptionDb)) {
                let text = this.$t('lang_MODULES_STORAGE_OPTION').replace(/<storage_limit>|<price>/gi, matched => {
                    return {
                        '<storage_limit>': element.storage_limit,
                        '<price>': this.$n(element.price, 'number')
                    }[matched]
                })

                let item = {
                    'value': element.id,
                    'text': text
                }
                 
                items.push(item)
            }

            return items
        },
        getStatusLabel(status) {
            if(status === 0 || status === false) return 'lang_ACCOUNT_MODULES_CHECKBOX_CAPTION_APPLY_NOW' 
            if(status === 1) return 'lang_ACCOUNT_MODULES_CHECKBOX_CAPTION_ACTIVATED'
            if(status === 2 || status === true) return 'lang_ACCOUNT_MODULES_CHECKBOX_CAPTION_IN_PROGRESS'
        }
    }
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
        table-layout: fixed;
    }
</style>